import PropTypes from 'prop-types';
import React from 'react';
import Styled from 'styled-components';
import { InfoOutlined } from '@material-ui/icons';
import Tooltip from '@material-ui/core/Tooltip';


const InfoTooltip = (props) => {
  return (
    <StyledTooltip title={props.title} placement={props.placement}>
      <InfoOutlinedIcon/>
    </StyledTooltip>
  );
};

InfoTooltip.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.string,
};

InfoTooltip.defaultProps = {
  placement: 'top',
};

const InfoOutlinedIcon = Styled(InfoOutlined)`
  margin: 5px;
  vertical-align: middle;
`;

const StyledTooltip = Styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ tooltip: className }} />
))`
  && {
    font-size: 13px;
    line-height: 1.5;
    max-width: 340px;
    padding: 10px 12px;
  }
`;

export default InfoTooltip;
